// PosterLightbox.js — Fullscreen image viewer for poster cards

import React, { useEffect } from 'react';

/**
 * PosterLightbox
 * @param {string} imageUrl - URL of the poster image
 * @param {Function} onClose - called when user closes the lightbox
 */
const PosterLightbox = ({ imageUrl, onClose }) => {
  // Close on ESC key
  useEffect(() => {
    const handleKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = 'unset';
    };
  }, [onClose]);

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4'
      onClick={onClose}
    >
      {/* Close button */}
      <button
        className='absolute top-4 right-4 text-white bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full w-10 h-10 flex items-center justify-center transition-colors z-10'
        onClick={onClose}
        aria-label='Close'
      >
        <svg className='w-5 h-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
        </svg>
      </button>

      {/* Image — stops propagation so clicking image doesn't close */}
      <img
        src={imageUrl}
        alt='Poster'
        className='max-w-full max-h-full object-contain rounded-lg shadow-2xl'
        onClick={e => e.stopPropagation()}
      />

      {/* Hint */}
      <p className='absolute bottom-4 text-white text-xs opacity-50'>
        Click outside to close
      </p>
    </div>
  );
};

export default PosterLightbox;
